import { Label } from '@/new/components/shadcn/label';
import { Textarea } from '@/new/components/shadcn/textarea';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export const StyleField = ({ value, onChange }: Props) => (
  <div className="flex flex-col gap-2">
    <Label htmlFor="download-style" className="text-sm font-medium text-gray-700">
      Document Style (optional)
    </Label>
    <Textarea
      id="download-style"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Write instructions or paste examples of how you would like each fact to be formatted. For example: a particular date format, to use more direct quotes from source text..."
      className="h-32 max-h-52 w-full"
    />
    <p className="text-xs text-gray-500">
      Wexler rewrites each fact according to the style or format you've instructed above. Visual style instructions will
      not be reflected in the download at this time.
    </p>
  </div>
);
